import { Component, Input } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
    selector: "app-tenant-selection-popup",
    templateUrl: "./tenant-selection-popup.component.html",
    styleUrls: ["./tenant-selection-popup.component.scss"],
    standalone: false
})
export class TenantSelectionPopupComponent {
  constructor() {}

  @Input()
  creditProvider: { value: string; url: string }[] = [];

  form: FormGroup = new FormGroup({
    cardProviderTenant: new FormControl(null, [Validators.required]),
  });

  ngOnInit() {
    this.form.patchValue({
      cardProviderTenant: "ENKASH",
    });
  }

  get cardProvider() {
    return this.form.get("cardProviderTenant").value;
  }
}
